/* Kameo matras-keuzehulp (collectie modern-v3)
   Opent vanaf elke link met [data-kkh-open]. Stelt 5 tikvragen (bij samen slapen 6),
   kiest met vaste regels Essence Foam, Flow of Flex, en licht daarna de juiste kaart
   op de pagina op. Kaarten worden herkend aan hun titel (Essence / Flow / Flex),
   zodat het advies blijft kloppen als het product op een kaart wordt omgezet.
   Prijs, beeld en link in het advies komen van diezelfde kaart.

   Meten: elk antwoord, het advies en de vervolgklik gaan (alleen met
   statistiek-consent) naar de events-tabel van de Kameo Cart-app, met bron
   'keuzehulp', plus een dataLayer-event 'kameo_keuzehulp' voor GA4. */
(function () {
  'use strict';
  if (window.__kkh) return;
  window.__kkh = true;

  /* ── vragen: [waarde, label] ── */
  var VRAGEN_MATRAS = [
    { id: 'wie', titel: 'Voor wie is het matras?', opties: [
      ['alleen', 'Alleen voor mij'],
      ['samen', 'Voor mij en mijn partner']] },
    { id: 'hardheid', alleenBij: function (a) { return a.wie === 'samen'; },
      titel: 'Houden jullie van dezelfde hardheid?', opties: [
      ['zelfde', 'Ja, dezelfde hardheid'],
      ['verschil', 'Nee, de een zachter, de ander steviger'],
      ['weet', 'Weet ik niet']] },
    { id: 'houding', titel: 'Hoe slaap je meestal?', opties: [
      ['zij', 'Op mijn zij'],
      ['rug', 'Op mijn rug'],
      ['buik', 'Op mijn buik'],
      ['wisselend', 'Wisselend']] },
    { id: 'gewicht', titel: function (a) { return a.wie === 'samen' ? 'Hoeveel weegt de zwaarste van jullie?' : 'Hoeveel weeg je ongeveer?'; },
      opties: [
      ['tot70', 'Tot 70 kg'],
      ['70-85', '70 tot 85 kg'],
      ['85-110', '85 tot 110 kg'],
      ['110plus', 'Meer dan 110 kg']] },
    { id: 'prio', titel: 'Wat vind je het belangrijkst?', opties: [
      ['prijs', 'Een voordelige prijs'],
      ['balans', 'Een goede balans'],
      ['instellen', 'Zo veel mogelijk zelf instellen']] },
    { id: 'warm', titel: 'Slaap je warm?', opties: [
      ['vaak', 'Ja, ik heb het snel warm'],
      ['soms', 'Soms'],
      ['nee', 'Nee']] }
  ];

  var NAMEN_MATRAS = { essence: 'Kameo® Essence Matras', flow: 'Kameo® Flow Matras', flex: 'Kameo® Flex Matras' };

  /* ── beslisregels (eerste die past wint) ──────────────────────────────
     Feiten komen van de productpagina's (pdp-d, pdp-d-flow, pdp-d-essence-foam). */
  function adviesMatras(a) {
    if (a.gewicht === '110plus') return { p: 'flex', regel: 1, redenen: [
      'Geschikt tot 130 kg per slaper, ook bij een tweepersoonsmaat',
      '6 instellingen in 1 matras, zodat je zelf kiest hoe je ligt'] };
    if (a.wie === 'samen' && (a.hardheid === 'verschil' || a.hardheid === 'weet')) return { p: 'flow', regel: 2, tweede: 'flex2x', redenen: [
      'Vanaf 140 cm breed stelt ieder zijn eigen kant in: jij stevig, je partner zacht',
      'Eén matras zonder naad in het midden, met 4 comfortniveaus'] };
    if (a.prio === 'instellen') return { p: 'flex', regel: 3, redenen: [
      '6 instellingen in 1 matras, thuis in een paar minuten om te zetten',
      'FlexGrid met ruim 1000 luchtkanalen voert warmte af'] };
    if (a.warm === 'vaak') {
      if (a.prio === 'prijs') return { p: 'flow', regel: 4, tweede: 'flex', redenen: [
        '8x betere ventilatie dankzij FlowSpring schuimveren',
        '4 comfortniveaus in 1 matras, voor minder dan de Flex'] };
      return { p: 'flex', regel: 4, redenen: [
        'FlexGrid voert warmte actief af met ruim 1000 luchtkanalen',
        '6 instellingen in 1 matras, zodat je zelf kiest hoe je ligt'] };
    }
    if (a.prio === 'prijs') return { p: 'essence', regel: 5, redenen: [
      'Het voordeligste aanpasbare Kameo matras',
      'Keer de kern en kies zelf: medium of firm',
      'Beoordeeld met een 7,0 door de Consumentenbond'] };
    return { p: 'flow', regel: 6, redenen: [
      'Optimale ventilatie: 8x beter dan gewoon schuim',
      '4 comfortniveaus in 1 matras, thuis om te zetten'] };
  }

  /* startinstelling: alleen regels die al op de productpagina's staan */
  function tipMatras(p, a) {
    if (p === 'essence') {
      if (a.wie === 'samen' && (a.hardheid === 'verschil' || a.hardheid === 'weet'))
        return 'Bij een tweepersoonsmaat keer je de kern voor jullie allebei. Ieder een eigen hardheid? Kies dan 2 eenpersoonsmatrassen.';
      return a.gewicht === '85-110'
        ? 'Weeg je meer dan 85 kg, begin dan op de firm kant.'
        : 'Onder de 85 kg past de medium kant meestal het best.';
    }
    if (a.houding === 'buik') return 'Als buikslaper lig je meestal fijner wat vlakker. De instelhulp op de productpagina wijst je de stevigere stand.';
    return 'Je matras komt binnen in instelling 1, de meest gekozen stand. Geef hem een week en stel daarna bij als je zachter of steviger wilt liggen.';
  }

  /* ── toppers (collectie toppers-v1) ──────────────────────────────────
     Feiten van de productpagina's pdp-d-essence-topper / -flow-topper / -flex-topper,
     aangevuld door Steinar: de Flex Topper ligt ook wat steviger, de Flow Topper
     heeft 2 comforts (keerbaar: soepel of wat steviger). */
  var VRAGEN_TOPPER = [
    { id: 'doel', titel: 'Wat wil je verbeteren aan je bed?', opties: [
      ['te_hard', 'Mijn matras voelt te hard'],
      ['steviger', 'Ik wil net wat steviger liggen'],
      ['naad', 'Er zit een naad tussen twee matrassen'],
      ['warm', 'Ik slaap te warm'],
      ['comfort', 'Gewoon meer comfort']] },
    { id: 'houding', titel: 'Hoe slaap je meestal?', opties: [
      ['zij', 'Op mijn zij'],
      ['rug', 'Op mijn rug'],
      ['buik', 'Op mijn buik'],
      ['wisselend', 'Wisselend']] },
    { id: 'schouders', titel: 'Heb je last van je schouders of heupen?', opties: [
      ['ja', 'Ja'],
      ['nee', 'Nee']] },
    { id: 'warm', titel: 'Slaap je warm?', opties: [
      ['vaak', 'Ja, ik heb het snel warm'],
      ['soms', 'Soms'],
      ['nee', 'Nee']] },
    { id: 'prio', titel: 'Wat vind je het belangrijkst?', opties: [
      ['prijs', 'Een voordelige prijs'],
      ['balans', 'Een goede balans'],
      ['beste', 'Het beste comfort']] }
  ];
  var NAMEN_TOPPER = { essence: 'Kameo® Essence Topper', flow: 'Kameo® Flow Topper', flex: 'Kameo® Flex Topper' };
  var R = {
    flexKoel: 'Onze koelste topper: FlexGrid voert warmte actief af',
    flexStevig: '8 cm premium comfort dat wat steviger ligt, zonder traagschuim',
    flexDruk: 'FlexGrid werkt drukverlagend bij schouders en heupen',
    flow2: '2 comforts in 1: soepel of wat steviger, gewoon omkeren',
    flowZones: '5 comfortzones ontlasten schouders en heupen',
    flowVent: '8x betere ventilatie dankzij FlowSpring schuimveren',
    essStevig: 'Ligt net wat steviger, voor een klein bedrag',
    essNaad: 'Eén doorlopende laag: weg met de naad in het midden',
    essVent: '6 cm FlowSpring schuimveren die 8x beter ventileren'
  };
  function adviesTopper(a) {
    if (a.warm === 'vaak' || a.doel === 'warm') {
      if (a.prio === 'prijs') return { p: 'flow', regel: 1, redenen: [R.flowVent, R.flow2],
        tweedeHtml: 'Heb je het echt snel warm? De <strong>Flex Topper</strong> is onze koelste topper.' };
      return { p: 'flex', regel: 1, redenen: [R.flexKoel, R.flexStevig] };
    }
    if (a.doel === 'te_hard') return { p: 'flow', regel: 2, redenen: [R.flow2, R.flowZones] };
    if (a.doel === 'naad') return { p: 'essence', regel: 3, redenen: [R.essNaad, R.essVent] };
    if (a.doel === 'steviger') {
      if (a.prio === 'beste') return { p: 'flex', regel: 4, redenen: [R.flexStevig, R.flexKoel] };
      return { p: 'essence', regel: 4, redenen: [R.essStevig, R.essVent],
        tweedeHtml: 'Twijfel je nog? De <strong>Flow Topper</strong> heeft een soepele én een stevigere kant.' };
    }
    if (a.schouders === 'ja') {
      if (a.prio === 'beste') return { p: 'flex', regel: 5, redenen: [R.flexDruk, R.flexKoel] };
      return { p: 'flow', regel: 5, redenen: [R.flowZones, R.flow2] };
    }
    if (a.prio === 'prijs') return { p: 'essence', regel: 6, redenen: [R.essStevig, R.essVent] };
    if (a.prio === 'beste') return { p: 'flex', regel: 7, redenen: [R.flexStevig, R.flexKoel] };
    return { p: 'flow', regel: 8, redenen: [R.flow2, R.flowVent] };
  }
  function tipTopper(p, a) {
    if (p === 'flow') return a.doel === 'steviger'
      ? 'Leg de stevigere kant boven. Liever soepeler? Rits de hoes open en draai de kern om.'
      : 'Begin met de soepele kant boven. Liever wat steviger? Rits de hoes open en draai de kern om.';
    return 'Leg de topper op je huidige matras. De antislip onderzijde houdt hem netjes op zijn plek.';
  }

  /* ── config (dealteksten uit de productmetafields, alleen als de actie aan staat) ── */
  var CONFIG = {};
  try { CONFIG = JSON.parse((document.getElementById('kkh-config') || {}).textContent || '{}'); } catch (e) {}
  // One homepage can open either existing flow; collection config still works.
  var ROOT_CONFIG = CONFIG;
  var TYPE, VRAGEN, NAMEN, advies, tip, BRON, OPSLAG;
  function kiesType(requested) {
    TYPE = (requested || ROOT_CONFIG.type) === 'topper' ? 'topper' : 'matras';
    CONFIG = ROOT_CONFIG.types ? (ROOT_CONFIG.types[TYPE] || {}) : ROOT_CONFIG;
    VRAGEN = TYPE === 'topper' ? VRAGEN_TOPPER : VRAGEN_MATRAS;
    NAMEN = TYPE === 'topper' ? NAMEN_TOPPER : NAMEN_MATRAS;
    advies = TYPE === 'topper' ? adviesTopper : adviesMatras;
    tip = TYPE === 'topper' ? tipTopper : tipMatras;
    BRON = TYPE === 'topper' ? 'keuzehulp-topper' : 'keuzehulp';
    OPSLAG = TYPE === 'topper' ? 'kkh_advies_topper' : 'kkh_advies';
  }
  kiesType();

  /* ── kaarten op de pagina ────────────────────────────────────────────── */
  function sleutel(tekst) {
    tekst = (tekst || '').toLowerCase();
    if (tekst.indexOf('essence') > -1) return 'essence';
    if (tekst.indexOf('flow') > -1) return 'flow';
    if (tekst.indexOf('flex') > -1) return 'flex';
    return null;
  }
  function kaarten() {
    var uit = {};
    document.querySelectorAll('.product-card-modern.pcm2').forEach(function (k) {
      var s = sleutel((k.querySelector('.product-card-modern__title') || {}).textContent);
      if (s && !uit[s]) uit[s] = k;
    });
    return uit;
  }
  function kaartUrl(k) {
    var a = k && k.querySelector('.product-card-modern__button');
    var h = a && a.getAttribute('href');
    return h && h !== '#' ? h : null;
  }
  function kaartPrijs(k) {
    var p = k && k.querySelector('.product-card-modern__price .price');
    if (!p) return null;
    var t = p.textContent.trim();
    if (!t) return null;
    var v = k.querySelector('.product-card-modern__price .compare-at-price');
    var pre = (k.querySelector('.product-card-modern__price_prefix') || {}).textContent || '';
    var geld = function (x) { x = x.trim(); return /€/.test(x) ? x : '€ ' + x; };
    return { prijs: geld(t), vergelijk: v && v.textContent.trim() ? geld(v.textContent) : null, va: /v\.a\./i.test(pre) };
  }
  /* één rood actielabel, dat bij de vanafprijs hoort: de 1+1 uit het metafield
     (alleen als die actie aan staat, want de vanafprijs is een eenpersoonsmaat),
     anders het kortingslabel van de kaart */
  function deals(p, k) {
    var d = (CONFIG.deals || {})[p];
    if (d) return [d];
    var lab = k && k.querySelector('.pcm2__discount');
    return lab && lab.textContent.trim() ? [lab.textContent.trim()] : [];
  }

  /* ── meten ───────────────────────────────────────────────────────────── */
  function magMeten() {
    try {
      if (window.Cookiebot && window.Cookiebot.consent) return !!window.Cookiebot.consent.statistics;
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && cp.analyticsProcessingAllowed) return cp.analyticsProcessingAllowed();
    } catch (e) {}
    return false;
  }
  function sessie() {
    var m = document.cookie.match('(?:^|; )kmc_sid=([^;]*)');
    if (m) return decodeURIComponent(m[1]);
    var id = (window.crypto && crypto.randomUUID) ? crypto.randomUUID()
      : Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
    document.cookie = 'kmc_sid=' + id + ';path=/;max-age=2592000;SameSite=Lax';
    return id;
  }
  function meet(event, code, slot) {
    if (/kab_force|kkh_test/.test(location.search)) return; // eigen QA niet meetellen
    try {
      (window.dataLayer = window.dataLayer || []).push({ event: 'kameo_keuzehulp', kh_actie: event, kh_code: code || null, kh_slot: slot || null });
    } catch (e) {}
    try {
      if (!magMeten()) return;
      var b = Math.min(innerWidth, innerHeight);
      var lading = JSON.stringify({
        sessie: sessie(),
        apparaat: b < 768 ? 'mobile' : b < 1024 ? 'tablet' : 'desktop',
        events: [{ event: event, ts: Date.now(), bron: BRON, code: code || null, slot: slot || null }]
      });
      var pad = '/apps/kameo-cart/e';
      if (!(navigator.sendBeacon && navigator.sendBeacon(pad, new Blob([lading], { type: 'application/json' })))) {
        fetch(pad, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: lading, keepalive: true }).catch(function () {});
      }
    } catch (e) { /* meten mag de keuzehulp nooit breken */ }
  }

  /* ── modal ───────────────────────────────────────────────────────────── */
  var el, band, paneel, stap = 0, antwoorden = {}, laatsteFocus = null, uitkomst = null;

  function zichtbareVragen() {
    return VRAGEN.filter(function (v) { return !v.alleenBij || v.alleenBij(antwoorden); });
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function bouw() {
    el = document.createElement('div');
    el.className = 'kkh';
    el.hidden = true;
    el.innerHTML =
      '<div class="kkh__achter" data-kkh-sluit></div>' +
      '<div class="kkh__vel" role="dialog" aria-modal="true" aria-labelledby="kkh-kop">' +
        '<div class="kkh__top">' +
          '<div class="kkh__balk">' +
            '<button type="button" class="kkh__rond kkh__terug" aria-label="Vorige vraag"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m15 18-6-6 6-6"/></svg></button>' +
            '<div class="kkh__voortgang" aria-hidden="true"><span></span></div>' +
            '<button type="button" class="kkh__rond kkh__sluit" data-kkh-sluit aria-label="Sluiten"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg></button>' +
          '</div>' +
          '<div class="kkh__band"></div>' +
        '</div>' +
        '<div class="kkh__paneel" aria-live="polite"></div>' +
      '</div>';
    document.body.appendChild(el);
    band = el.querySelector('.kkh__band');
    paneel = el.querySelector('.kkh__paneel');
    el.addEventListener('click', function (e) {
      if (e.target.closest('[data-kkh-sluit]')) { e.preventDefault(); sluit('knop'); }
    });
    el.querySelector('.kkh__terug').addEventListener('click', function () {
      if (uitkomst) { uitkomst = null; stap = zichtbareVragen().length - 1; }
      else if (stap > 0) stap--;
      toonVraag(-1);
    });
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { sluit('esc'); return; }
      if (e.key !== 'Tab') return;
      var f = el.querySelectorAll('button:not([hidden]):not([disabled]), a[href]');
      f = Array.prototype.filter.call(f, function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    });
  }

  function voortgang(fractie) {
    el.querySelector('.kkh__voortgang span').style.transform = 'scaleX(' + Math.max(0.04, fractie) + ')';
  }

  function wissel(bandHtml, html, richting, klasse) {
    [band, paneel].forEach(function (x) { x.classList.remove('kkh--in', 'kkh--terug'); });
    void paneel.offsetWidth;
    band.innerHTML = bandHtml;
    paneel.innerHTML = html;
    el.querySelector('.kkh__vel').classList.toggle('kkh__vel--advies', klasse === 'advies');
    [band, paneel].forEach(function (x) { x.classList.add(richting < 0 ? 'kkh--terug' : 'kkh--in'); });
    paneel.scrollTop = 0;
  }

  function toonVraag(richting) {
    var lijst = zichtbareVragen();
    var v = lijst[stap];
    var titel = typeof v.titel === 'function' ? v.titel(antwoorden) : v.titel;
    el.querySelector('.kkh__terug').hidden = stap === 0;
    voortgang((stap + 1) / (lijst.length + 1));
    var b = '<p class="kkh__stap">Vraag ' + (stap + 1) + '</p>' +
      '<h2 class="kkh__kop" id="kkh-kop">' + esc(titel) + '</h2>' +
      (v.sub ? '<p class="kkh__sub">' + esc(v.sub) + '</p>' : '');
    var h = '<div class="kkh__opties" role="radiogroup" aria-labelledby="kkh-kop">';
    v.opties.forEach(function (o) {
      var gekozen = antwoorden[v.id] === o[0];
      h += '<button type="button" role="radio" aria-checked="' + gekozen + '" class="kkh__optie' + (gekozen ? ' is-gekozen' : '') + '" data-waarde="' + o[0] + '">' +
        '<span class="kkh__label">' + esc(o[1]) + '</span><span class="kkh__bol" aria-hidden="true"></span></button>';
    });
    h += '</div>';
    wissel(b, h, richting);
    paneel.querySelectorAll('.kkh__optie').forEach(function (knop) {
      knop.addEventListener('click', function () { kies(v, knop); });
    });
    var eerst = paneel.querySelector('.is-gekozen') || paneel.querySelector('.kkh__optie');
    if (eerst) eerst.focus({ preventScroll: true });
  }

  var bezig = false;
  function kies(v, knop) {
    if (bezig) return;
    bezig = true;
    antwoorden[v.id] = knop.getAttribute('data-waarde');
    if (v.id === 'wie' && antwoorden.wie !== 'samen') delete antwoorden.hardheid;
    paneel.querySelectorAll('.kkh__optie').forEach(function (b) {
      var aan = b === knop;
      b.classList.toggle('is-gekozen', aan);
      b.setAttribute('aria-checked', aan);
    });
    meet('kh_antwoord', v.id + ':' + antwoorden[v.id], stap + 1);
    setTimeout(function () {
      bezig = false;
      var lijst = zichtbareVragen();
      if (stap < lijst.length - 1) { stap++; toonVraag(1); }
      else toonAdvies();
    }, 240);
  }

  function toonAdvies() {
    uitkomst = advies(antwoorden);
    var k = kaarten();
    var p = uitkomst.p, kaart = k[p], url = kaartUrl(kaart), prijs = kaartPrijs(kaart), acties = deals(p, kaart);
    var product = (CONFIG.products || {})[p] || {};
    url = url || product.url;
    prijs = prijs || product.price;
    voortgang(1);
    el.querySelector('.kkh__terug').hidden = false;
    meet('kh_advies', p, uitkomst.regel);
    try { sessionStorage.setItem(OPSLAG, p); } catch (e) {}

    var b = '<span class="kkh__match">Beste keuze voor jou</span>' +
      '<h2 class="kkh__kop kkh__kop--product" id="kkh-kop">' + esc(NAMEN[p]) + '</h2>';

    var h = '';
    if (acties.length || prijs) {
      h += '<div class="kkh__prijsrij">' +
        (acties.length ? '<div class="kkh__acties-labels">' + acties.map(function (a) { return '<span class="kkh__deal">' + esc(a) + '</span>'; }).join('') + '</div>' : '') +
        (prijs ? '<p class="kkh__prijs">' + (prijs.va ? '<span class="kkh__va">vanaf</span>' : '') +
          '<strong>' + esc(prijs.prijs) + '</strong>' +
          (prijs.vergelijk ? '<s>' + esc(prijs.vergelijk) + '</s>' : '') + '</p>' : '') +
        '</div>';
    }
    h += '<ul class="kkh__redenen">';
    uitkomst.redenen.forEach(function (r) {
      h += '<li><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg><span>' + esc(r) + '</span></li>';
    });
    h += '</ul><p class="kkh__tip">' + esc(tip(p, antwoorden)) + '</p>';

    if (uitkomst.tweede === 'flex2x') {
      var d2 = (CONFIG.deals || {}).flex;
      h += '<p class="kkh__tweede">Liever ieder een volledig eigen matras? Kies 2 eenpersoons <strong>Flex</strong> matrassen, met elk 6 instellingen' + (d2 ? ' (' + esc(d2) + ')' : '') + '.</p>';
    } else if (uitkomst.tweede === 'flex') {
      h += '<p class="kkh__tweede">Heb je het echt snel warm? Het <strong>Flex</strong> matras verkoelt actief met FlexGrid.</p>';
    } else if (uitkomst.tweedeHtml) {
      h += '<p class="kkh__tweede">' + uitkomst.tweedeHtml + '</p>';
    }

    h += '<div class="kkh__knoppen">' +
      (kaart ? '<button type="button" class="button kkh__knop" data-kkh-toon>Toon op de pagina</button>' : '') +
      (url ? '<a class="button button-secondary kkh__knop" href="' + esc(url) + '" data-kkh-bekijk>Bekijk ' + (TYPE === 'topper' ? 'topper' : 'matras') + '</a>' : '') +
      '</div>' +
      '<p class="kkh__chat"><a href="#kameo-chat" data-kkh-chat>Nog vragen? Chat met een slaapexpert</a></p>' +
      '<p class="kkh__opnieuw"><button type="button" data-kkh-opnieuw>Opnieuw beginnen</button></p>';
    wissel(b, h, 1, 'advies');

    var toon = paneel.querySelector('[data-kkh-toon]');
    if (toon) toon.addEventListener('click', function () { meet('kh_klik', 'toon', uitkomst.regel); sluit('advies'); markeer(p, true); });
    var bekijk = paneel.querySelector('[data-kkh-bekijk]');
    if (bekijk) bekijk.addEventListener('click', function () { meet('kh_klik', 'bekijk:' + p, uitkomst.regel); });
    paneel.querySelector('[data-kkh-chat]').addEventListener('click', function (e) {
      e.preventDefault();
      meet('kh_klik', 'chat', uitkomst.regel);
      sluit('chat');
      // de chatwidget luistert naar klikken op links met href="#kameo-chat"
      var a = document.createElement('a');
      a.href = '#kameo-chat'; a.style.display = 'none';
      document.body.appendChild(a); a.click(); a.remove();
    });
    paneel.querySelector('[data-kkh-opnieuw]').addEventListener('click', function () {
      antwoorden = {}; uitkomst = null; stap = 0; toonVraag(-1);
    });
    (toon || bekijk || paneel.querySelector('a, button')).focus({ preventScroll: true });
  }

  /* ── kaart oplichten ─────────────────────────────────────────────────── */
  function markeer(p, scroll) {
    var k = kaarten();
    Object.keys(k).forEach(function (s) {
      k[s].classList.remove('kkh-match');
      var oud = k[s].querySelector('.kkh-badge');
      if (oud) oud.remove();
    });
    var kaart = k[p];
    if (!kaart) return;
    kaart.classList.add('kkh-match');
    document.documentElement.classList.add('kkh-heeft-advies');
    var badge = document.createElement('span');
    badge.className = 'kkh-badge';
    badge.textContent = 'Beste keuze voor jou';
    kaart.insertBefore(badge, kaart.firstChild);
    if (!scroll) return;
    var slide = kaart.closest('.swiper-slide');
    var houder = kaart.closest('.swiper-initialized') || kaart.closest('.collection-modern');
    if (slide && houder && houder.swiper) {
      var i = Array.prototype.indexOf.call(slide.parentNode.children, slide);
      try { houder.swiper.slideTo(i, 500); } catch (e) {}
    }
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    // de kaart is vaak hoger dan het scherm: scrol naar de bovenkant, onder de vaste header
    var kop = document.querySelector('.header-section');
    var kopHoogte = kop && /sticky|fixed/.test(getComputedStyle(kop).position) ? kop.offsetHeight : 0;
    var doel = kaart.getBoundingClientRect().top + scrollY - kopHoogte - 24;
    window.scrollTo({ top: Math.max(0, doel), behavior: reduce ? 'auto' : 'smooth' });
  }

  /* ── openen / sluiten ────────────────────────────────────────────────── */
  function open(e, trigger) {
    if (e) e.preventDefault();
    kiesType(trigger && trigger.getAttribute('data-kkh-type'));
    if (!el) bouw();
    laatsteFocus = document.activeElement;
    antwoorden = {}; uitkomst = null; stap = 0;
    el.hidden = false;
    document.documentElement.classList.add('kkh-open');
    requestAnimationFrame(function () { el.classList.add('is-open'); });
    toonVraag(1);
    meet('kh_open', null, null);
  }
  function sluit(reden) {
    if (!el || el.hidden) return;
    // afhaken: welke vraag stond open (de naam, want het nummer verschuift bij 'samen')
    if (!uitkomst) meet('kh_sluit', ((zichtbareVragen()[stap] || {}).id || '?') + ':' + (reden || ''), stap + 1);
    el.classList.remove('is-open');
    document.documentElement.classList.remove('kkh-open');
    setTimeout(function () { el.hidden = true; }, 220);
    if (laatsteFocus && laatsteFocus.focus) laatsteFocus.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-kkh-open]');
    if (t) open(e, t);
  });

  /* terug van een productpagina: het eerdere advies blijft zichtbaar */
  function herstel() {
    try { var p = sessionStorage.getItem(OPSLAG); if (p) markeer(p, false); } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', herstel);
  else herstel();
})();
